import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

const Tabs = ({
  className,
  options,
  value,
  onChange,
}: {
  className?: string;
  options: { id: string; label: ReactNode }[];
  value: string;
  onChange: (id: string) => void;
}) => {
  return (
    <Root className={className}>
      {options.map(({ id, label }) => (
        <Tab
          key={id}
          onClick={() => onChange(id)}
          selected={value === id}
        >
          {label}
        </Tab>
      ))}
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.grey200}`,
  borderBottom: `1px solid ${theme.palette.grey200}`,
}));

const Tab = styled('div')<{ selected: boolean }>(
  ({ theme, selected }) => ({
    height: 44,
    padding: '0 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: selected
      ? theme.palette.primary.main
      : theme.palette.textPrimaryBlack,
    fontWeight: 500,
    borderBottom: `2px solid ${
      selected ? theme.palette.primary.main : 'transparent'
    }`,
    transition: '0.2s all ease-in-out',
    cursor: 'pointer',
  }),
);

export default Tabs;
